import { render, staticRenderFns } from "./OrdersDeleteDialog.vue?vue&type=template&id=80d417a2&scoped=true"
import script from "./OrdersDeleteDialog.vue?vue&type=script&lang=js"
export * from "./OrdersDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./OrdersDeleteDialog.vue?vue&type=style&index=0&id=80d417a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d417a2",
  null
  
)

export default component.exports